export default __webpack_public_path__ + "static/media/bacqueville.5a15cd8b.jpg";